import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'frodo-dialog-loading',
  templateUrl: './dialog-loading.component.html',
  styleUrls: ['./dialog-loading.component.scss'],
})
export class DialogLoadingComponent {
  colorSpinner = '#F8971D';
  timerSrc = '../../../../assets/timer.svg';
  logoSrc = '../../../../assets/logo.png';
  latestTap: number;

  constructor(
    private dialogRef: MatDialogRef<DialogLoadingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  refresh() {
    const now = new Date().getTime();
    const timeSince = now - this.latestTap;
    if (timeSince < 600 && timeSince > 0) {
      this.dialogRef.close({
        data: 'goBack',
      });
    }
    this.latestTap = new Date().getTime();
  }
}
